import { sampleDataSimulationLatestTips, sampleDataTopSupporter, getRandomInt, listSupporter } from "./index.preview";
import { debounce } from "lodash";
import { debuglog } from "../utility/debuglog";

let simulationRIS = 0;
let simulationListSupporter = listSupporter;

export default [
  {
    name: 'add',
    class: 'btn-add',
    label: 'add',
    exec: (manager) => {
      if(manager.get('rt_type') == 'latest-tips') {
        let temp = sampleDataSimulationLatestTips(getRandomInt(3), getRandomInt(2));
        manager.widget.tipsQueue.push(temp);
        debuglog(`New tip from ${temp.supporter.display_name} 💰 ${temp.supporter.quantity} ${temp.unit}`)
      } else {
        let point = getRandomInt(3)
        let temp = sampleDataTopSupporter(getRandomInt(2), point);
        simulationListSupporter.push(temp)
        debuglog(`New tip 💰 ${temp.supporter.sum} ${temp.unitName} from ${temp.supporter.supporter_name}`)
        
        reloadHandlerSimulation(manager,point)
      }
    },
  },
  {
    name: 'Simulation',
    class: 'btn-reload-simulation',
    label: 'Simulation',
    exec: (manager) => {

      // const times = [ 500, 1100, 1200, 2000, 3000, 3200, 3600, 4000, 4200, 6100, 6200, 7400, 7700, 8900 ];
      const times = [ 500, 1100, 1200, 2000, 3000, 3200];
      // const times = [ 500, 1100, 1200];

      // simulation running in seconds

      setInterval(() => {
        // manager.widget.simulationRIS += 100
        simulationRIS += 100
      }, 100)

      times.forEach((data, index) => {
        setTimeout(() => {
          reloadSimulation(index);
        }, data);
      });



      async function reloadSimulation(index) {

        const amount = Math.floor(Math.random() * 1000);
        debuglog(`[${simulationRIS}ms] New tip 💰 ${amount} unit`);

        if(manager.get('rt_type') == 'latest-tips') {
          // let data = sampleDataSimulationLatestTips(simulationRIS, index)
          let data = sampleDataSimulationLatestTips(amount, index)
          manager.widget.tipsQueue.push(data);
        } else {
          let temp = sampleDataTopSupporter(getRandomInt(2), simulationRIS);
          listSupporter.push(temp);
          
          reloadHandlerSimulation(manager,simulationRIS)
        }
      }


    }
  },
  {
    name: 'Pause',
    class: 'btn-pause-marquee',
    label: 'Pause',
    exec: (manager) => {
      
      debuglog("Running text stop")
      manager.widget.pause();
    }
  },
  {
    name: 'Play',
    class: 'btn-play-marquee',
    label: 'Play',
    exec: (manager) => {
      debuglog("Running text run")
      manager.widget.play();
    }
  },
  {
    name: 'LongText',
    class: 'btn-debug-longtext',
    label: 'Long Text',
    exec: (manager) => {
      
      debuglog("Check long text input")

      let text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
      let temp = h.cloneProp(manager.widget.data);
      if(manager.widget.setting['rt_type'] == 'top-supporters') {
        temp.supporter.supporter_name = "Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis"
        temp.supporter.sum = 999
        simulationListSupporter.push(temp)
        reloadHandlerSimulation(manager, temp.supporter.sum )
      } else {
        temp.supporter.display_name = "Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis";
        temp.supporter.support_message = text;
        manager.widget.tipsQueue.push(temp);
      }
    }
  },
  {
    name: 'emptyState',
    class: 'btn-debug-emptystate',
    label: 'Empty State',
    exec: async (manager) => {
      manager.widget.messageBuilder = [];
      await manager.addMsgOnTail()
      manager.updateMarquee()
      debuglog("Reset to empty state")
    }
  },
];

let reloadHandlerSimulation = debounce(async (manager, point) => {
  debuglog(`[${simulationRIS}ms] Data has reload 💰 ${point}`)

  if(manager.get('rt_type') == 'top-supporters') {
    //sort list supporter
    simulationListSupporter.sort((a, b) => b.supporter.sum - a.supporter.sum);
    simulationListSupporter.splice(manager.widget.limit());
    let tempSupporter = [];
    let limitSupporter = (simulationListSupporter.length > manager.widget.limit()) ? manager.widget.limit() : simulationListSupporter.length
    for (let i = 0; i < limitSupporter; i++) {
      tempSupporter.push(simulationListSupporter[i])
    }

    if(tempSupporter.length > 0 ) {
      manager.widget.messageBuilder = [];
      await manager.addMsgOnHead()

      tempSupporter.forEach(function(data,index) {
        var temp = {
          no: index + 1,
          supporter: data.supporter,
          icon: data.icon,
          unitName: data.unitName,
          pageUrl: data.pageUrl
        }
        
        manager.addRunningText(temp);
      });
      await manager.addMsgOnTail()
      manager.updateMarquee()

    }
  }
}, 500, { 'maxWait': 1000 });